export default __webpack_public_path__ + "static/media/postSuvinil6.1d62a36d.gif";